import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

import "./dashboard.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

function HomeScreen() {
  const [showUploadVideo, setShowUploadVideo] = useState(false);
  const [uploadedVideoData, setUploadedVideoData] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("userDetails");
    if (!userId) {
      navigate("/login");
    }
  }, [navigate]);

  const uploadNewVideo = () => {
    setShowUploadVideo(true);
    setUploadedVideoData(null);
  };

  const handleVideoUpload = (event: any) => {
    // const file = event.target.files[0];
    // const reader = new FileReader();
    // reader.onload = () => {
    //   setUploadedVideoData(reader.result);
    // };
    // reader.readAsDataURL(file);
    setUploadedVideoData({
      videoUri: "https://example.com/video.mp4",
      data: {
        ai_summary:
          "Player shows good footwork but needs improvement in smash power...",
        detected_errors: [
          {
            detail: "Low wrist speed detected",
            recommendation: "Practice wrist snap drills",
            severity: "medium",
            type: "weak_smash",
          },
        ],
        features: {
          avg_knee_angle: 90,
          avg_shoulder_angle: 45,
          avg_wrist_speed: 2.5,
          contact_events: [
            {
              frame: 50,
              type: "smash",
            },
          ],
          frames: 300,
          recovery_time: 500,
        },
        performance_score: 75.5,
        player_id: "PLR001",
        recommendations: [
          "Shadow swing drills",
          "Ladder footwork training",
          "Wrist strength exercises",
        ],
        session_id: "SESSION_001",
        timestamp: "2024-01-15T10:30:00",
      },
    });
  };

  return (
    <>
      <Header />
      <div className="admin-home-container">
        <div className="container main-container">
          <h4>Dashboard</h4>
          <div className="card">
            {showUploadVideo ? (
              <>
                <div className="row">
                  <div className="col-4">
                    <h5>Upload New Video</h5>
                    <input type="file" id="myFile" name="filename" />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-2">
                    <Button
                      id="basic-button"
                      variant="contained"
                      onClick={handleVideoUpload}
                    >
                      Upload Video
                    </Button>
                  </div>
                  <div className="col-2">
                    <Button
                      id="basic-button"
                      variant="outlined"
                      onClick={() => setShowUploadVideo(false)}
                    >
                      Back
                    </Button>
                  </div>
                </div>
                {uploadedVideoData?.data && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <h5>Video Details</h5>
                      <div className="row">
                        <div className="col-4">
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-title">Player ID:</h5>
                              <h6 className="card-subtitle mb-2 text-muted">
                                {uploadedVideoData?.data?.player_id}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-title">Performance score:</h5>
                              <h6 className="card-subtitle mb-2 text-muted">
                                {uploadedVideoData?.data?.performance_score}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-header">Detected Errors:</div>
                            <div className="card-body">
                              {uploadedVideoData?.data?.detected_errors
                                ?.length > 0 ? (
                                <div>
                                  <p>
                                    <strong>Type:</strong>&nbsp;
                                    {
                                      uploadedVideoData.data.detected_errors[0]
                                        .type
                                    }
                                  </p>
                                  <p>
                                    <strong>Detail:</strong>&nbsp;
                                    {
                                      uploadedVideoData.data.detected_errors[0]
                                        .detail
                                    }
                                  </p>
                                  <p>
                                    <strong>Recommendation:</strong>
                                    &nbsp;
                                    {
                                      uploadedVideoData.data.detected_errors[0]
                                        .recommendation
                                    }
                                  </p>
                                  <p>
                                    <strong>Severity:</strong>&nbsp;
                                    {
                                      uploadedVideoData.data.detected_errors[0]
                                        .severity
                                    }
                                  </p>
                                </div>
                              ) : (
                                <p>No errors found</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-header">
                              Improvement Recommendations:
                            </div>
                            <div className="card-body">
                              {uploadedVideoData?.data?.recommendations
                                ?.length > 0 ? (
                                <>
                                  {uploadedVideoData.data.recommendations.map(
                                    (recommendation: any, index: number) => (
                                      <div key={index}>
                                        <p><strong>{index + 1}.</strong> {recommendation}</p>
                                      </div>
                                    )
                                  )}
                                </>
                              ) : (
                                <p>Improvement recommendations not found</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="row">
                <div className="col-4">
                  <Button
                    id="basic-button"
                    variant="contained"
                    onClick={uploadNewVideo}
                  >
                    Analyze New Video
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default HomeScreen;
